/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';

export const RenderSectionTotalContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  @media screen and (max-width: 768px) { 
    width: 65%;
    margin-left:45%;
  }
`;

